import React from "react";
import { connect } from "react-redux";

import './commonFilter.css';


class BillFilter extends React.Component {
    constructor(props) {
        super(props);
        this.state = {
            phoneNo: this.props.phone,
            types: [
                { value: "Electricity", label: "Electricity" },
                { value: "Mobile", label: "Mobile" },
                { value: "Gas", label: "Gas" },
                { value: "Landline", label: "Landline" },
                { value: "Broadband", label: "Broadband" },
                { value: "Water", label: "Water" },
                { value: "Insurance", label: "Insurance" }

            ],
            statusValues: [
                { value: "Success", label: "Success" },
                { value: "Failed", label: "Failed" },
                { value: "Pending", label: "Pending" }
            ],

        }
    }

    componentDidMount() { }
    componentWillUnmount() {
    }


    render() {
       
        return (
            <div class="hisfltr">
                <div class="dropdown filbox">
                    <button type="button" class="dropdown-toggle fltrbtn" data-bs-auto-close="outside" id="fltrid" data-bs-toggle="dropdown" aria-expanded="false" aria-haspopup="true"></button>

                    <div class="dropdown-menu dropdown-menu-end" aria-labelledby="fltrid">
                        <form>
                            <div class="filters">
                                <label for="select-state">Type:</label>

                                <select data-placeholder="..."
                                    class="chosen-select" tabindex="8"
                                    onChange={this.typeSelect}>
                                    {this.state.types.map(type => (
                                        <option value={type.value}
                                        >{type.value}</option>
                                    ))}
                                </select>

                            </div>

                            <div class="filters">
                                <label for="select-state">Status:</label>

                                <select data-placeholder="..." 
                                    class="chosen-select" tabindex="8"
                                    onChange={this.statusSelect}>
                                    {this.state.statusValues.map(status => (
                                        <option value={status.value}
                                        >{status.value}</option>
                                    ))}
                                </select>

                            </div>

                            <div class="filters">
                                <label for="select-state">From:</label>
                                <input type="date" name="" placeholder="DD/MM/YYYY"
                                    onChange={this.selectFromDate} />
                            </div>
                            <div class="filters">
                                <label for="select-state">To:</label>
                                <input type="date" name="" placeholder="DD/MM/YYYY"
                                    onChange={this.selectToDate} />
                            </div>
                            <div class="filters">
                                <button type="reset" class="clear" id="btnClear"
                                    onClick={this.reset}>Clear</button>
                            </div>
                        </form>
                    </div>
                </div>
            </div>
        );
    }
}

const mapStateToProps = (
    { errorMessageReduce: { errorMessage, loginErrorMessage, otpErrorMessage },
        miscReduce: { otpRefNo, phone } }
) => ({
    errorMessage, loginErrorMessage, otpErrorMessage, otpRefNo, phone
});

export default connect(mapStateToProps, null)(BillFilter);